import { render, staticRenderFns } from "./DatosXredes.vue?vue&type=template&id=75408e56"
import script from "./DatosXredes.vue?vue&type=script&lang=js"
export * from "./DatosXredes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports